import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year2/Spring/MassCapacityAndTemperature/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'MassCapacityAndTemperature',
  field: 'Measurement',
  weeks: [10, 12],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MassCapacityAndTemperature/1CompareMass" */ './1CompareMass'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MassCapacityAndTemperature/2MeasureInGrams" */ './2MeasureInGrams'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MassCapacityAndTemperature/3MeasureInKilograms" */ './3MeasureInKilograms'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MassCapacityAndTemperature/4FourOperationsWithMass" */ './4FourOperationsWithMass'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MassCapacityAndTemperature/5CompareVolumeAndCapacity" */ './5CompareVolumeAndCapacity'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MassCapacityAndTemperature/6MeasureInMillilitres" */ './6MeasureInMillilitres'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MassCapacityAndTemperature/7MeasureInLitres" */ './7MeasureInLitres'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MassCapacityAndTemperature/8FourOperationsWithVolumeAndCapacity" */ './8FourOperationsWithVolumeAndCapacity'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MassCapacityAndTemperature/9Temperature" */ './9Temperature'
        )
    })
  ]
});
export default Block;
